import { sourceAccumulator } from '@/common/converter/utils/source-accumulator'
import { getCellType } from '@/common/util/home/get-cell-type'
import { getSubType } from '@/common/util/view-more/get-sub-type'

/**
 * homeData 에서 구형 Api 규격으로 컨버팅 할 경우
 * 필요한 데이터들을 해체해서 리턴 하는 함수
 * @param homeData
 * @returns {undefined|{layout: {}, filter: (*|{}), uiType: (*|string), subType: string, source: {eventList: ({cta: string, add_timestamp: string, method: string, add_common_params: string, bodylist: *, add_credential: string, type: string, url: *}|{}|{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined)[], contextProperty: *}, type: string, version: string, elementList: *[]}}
 */
export const dissectHome = (homeData) => {
  const { version = '', type = '', layout = {} } = homeData
  const { catalogList = [] } = layout?.catalog
  const [catalog] = catalogList

  if (catalogList.length <= 0) {
    return undefined
  }

  const { elementList = [] } = catalog

  const source = sourceAccumulator(elementList)
  const uiType = getCellType(elementList)
  const filter = homeData?.layout?.filter ?? {}
  const subType = getSubType(elementList)

  return {
    version,
    type,
    layout,
    filter,
    uiType,
    subType,
    elementList,
    source,
  }
}
